module.exports = function() {
  return new Worker(__webpack_public_path__ + "4d3db66ddc52f3aae91f.worker.js");
};